module.exports = __webpack_public_path__ + "static/media/4.eae3f9b3.jpg";